export default __webpack_public_path__ + "static/media/404.8a4510fe.svg";